// @flow
import { Map } from "immutable";

export const copValuesSelector = (state: Map<string, any>) =>
  state.getIn(["cop", "copValues"]);

export const copErrorSelector = state => state.getIn(["cop", "error"]);



// WEBPACK FOOTER //
// ./src/features/cop/store/copSelectors.js